import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Kumarakom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Kumarakom Bird Sanctuary",
        image: "/assets/img/bird-sanctuary.jpg",
        description: "A paradise for bird watchers, this sanctuary is home to migratory birds like Siberian storks, egrets, herons, and teals. Located on the banks of Vembanad Lake.",
        highlight: "Migratory Bird Haven",
        bestTime: "June-August",
        duration: "2-3 Hours",
        tip: "Early morning visits offer the best bird sightings"
      },
      {
        name: "Vembanad Lake",
        image: "/assets/img/vembanad-lake.jpg",
        description: "The longest lake in India, offering stunning sunset views, houseboat cruises, and water sports. The lake is a hub of activity with traditional fishing villages.",
        highlight: "Longest Lake in India",
        bestTime: "Sunset",
        duration: "2-4 Hours",
        tip: "Take a sunset cruise for spectacular views"
      },
      {
        name: "Houseboat Cruises",
        image: "/assets/img/kumarakom-houseboat.jpg",
        description: "Experience the luxury of traditional Kettuvallams with modern amenities. Cruise through the backwaters while enjoying authentic Kerala cuisine.",
        highlight: "Luxury Floating Experience",
        bestTime: "Oct-Mar",
        duration: "1-2 Nights",
        tip: "Book deluxe houseboat for premium experience"
      },
      {
        name: "Pathiramanal Island",
        image: "/assets/img/pathiramanal.jpeg",
        description: "A beautiful island in Vembanad Lake, accessible only by boat. Home to rare species of birds and lush vegetation.",
        highlight: "Hidden Island Paradise",
        bestTime: "Morning",
        duration: "2 Hours",
        tip: "Best for bird watching and photography"
      },
      {
        name: "Aruvikkuzhi Waterfall",
        image: "/assets/img/aruvikkuzhi.jpg",
        description: "A picturesque waterfall cascading from a height of 100 feet, surrounded by rubber plantations and scenic landscapes.",
        highlight: "Scenic Waterfall",
        bestTime: "Monsoon",
        duration: "1-2 Hours",
        tip: "Perfect for nature photography"
      },
      {
        name: "Bay Island Driftwood Museum",
        image: "/assets/img/driftwood-museum.jpeg",
        description: "A unique museum showcasing driftwood sculptures and artifacts collected from the backwaters.",
        highlight: "Unique Art Collection",
        bestTime: "All Year",
        duration: "1 Hour",
        tip: "Closed on Mondays"
      },
      {
        name: "Kumarakom Beach",
        image: "/assets/img/kumarakom-beach.jpg",
        description: "A serene beach along the backwaters, perfect for relaxation and evening walks. Enjoy stunning sunset views.",
        highlight: "Peaceful Retreat",
        bestTime: "Evening",
        duration: "1-2 Hours",
        tip: "Perfect for sunset photography"
      },
      {
        name: "St. Mary's Church",
        image: "/assets/img/st-marys-church.jpeg",
        description: "An ancient church with beautiful architecture, dating back to the 18th century. A peaceful spiritual retreat.",
        highlight: "Historic Church",
        bestTime: "Morning",
        duration: "30-45 mins",
        tip: "Visit during Christmas for celebrations"
      }
    ];

    const experiences = [
      {
        title: "Houseboat Stay",
        description: "Overnight cruise through backwaters with authentic Kerala cuisine",
        icon: "fas fa-ship"
      },
      {
        title: "Bird Watching",
        description: "Spot migratory birds at the famous bird sanctuary",
        icon: "fas fa-dove"
      },
      {
        title: "Village Tours",
        description: "Explore traditional fishing villages and local culture",
        icon: "fas fa-home"
      },
      {
        title: "Ayurvedic Wellness",
        description: "Rejuvenate with authentic Ayurvedic treatments",
        icon: "fas fa-spa"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Kottayam District, Kerala", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "October to February", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Cochin International Airport (85 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Kottayam Railway Station (16 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Backwaters, Bird Sanctuary, Houseboats", icon: "fas fa-water" },
      { label: "Language", value: "Malayalam, English, Hindi", icon: "fas fa-language" }
    ];

    const birdSpecies = [
      { name: "Siberian Stork", season: "Winter", image: "/assets/img/siberian-stork.jpg" },
      { name: "Egrets", season: "Year-round", image: "/assets/img/egrets.jpg" },
      { name: "Herons", season: "Year-round", image: "/assets/img/herons.jpg" },
      { name: "Teals", season: "Winter", image: "/assets/img/teals.jpg" }
    ];

    const culinaryDelights = [
      { name: "Karimeen Pollichathu", description: "Pearl spot fish wrapped and grilled in banana leaf" },
      { name: "Kerala Sadya", description: "Traditional vegetarian feast on banana leaf" },
      { name: "Kappa & Meen Curry", description: "Tapioca with spicy fish curry" },
      { name: "Fresh Toddy", description: "Local palm wine from coconut trees" }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/kumarakom-hero.png" alt="Kumarakom Backwaters" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Backwater Paradise</span>
            </div>
            <h1 className="dest-hero-title">Kumarakom</h1>
            <p className="dest-hero-subtitle">
              Where nature's serenity meets the tranquility of backwaters
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Kottayam District, Kerala, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Kumarakom</h2>
                <p className="dest-intro-description">
                  Kumarakom is a serene backwater destination nestled on the banks of Vembanad Lake, 
                  the largest lake in Kerala. This picturesque village is famous for its lush greenery, 
                  tranquil backwaters, and the world-renowned Kumarakom Bird Sanctuary.
                </p>
                <p className="dest-intro-description">
                  Once a sleepy village, Kumarakom has transformed into one of Kerala's most sought-after 
                  tourist destinations. The network of canals, lagoons, and waterways offers a unique 
                  opportunity to experience the traditional lifestyle of Kerala's backwater communities.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? Kumarakom's Vembanad Lake is the longest lake in India, spanning over 2,000 sq km across multiple districts.</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title">Experiences in Kumarakom</h2>
            <p className="dest-section-subtitle">
              Unique ways to explore the backwater paradise
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="exp-description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="dest-attractions-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title">Top Attractions in Kumarakom</h2>
            <p className="dest-section-subtitle">
              Discover the beauty and serenity of this backwater haven
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="dest-time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        <div className="dest-travel-tip">
                          <i className="fas fa-lightbulb"></i>
                          <span>{attraction.tip}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Bird Sanctuary Section */}
        <div className="bird-sanctuary-section">
          <div className="bird-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="bird-content">
                <div className="bird-badge">Paradise for Bird Lovers</div>
                <h2 className="bird-title">Kumarakom Bird Sanctuary</h2>
                <p className="bird-description">
                  Spread across 14 acres on the banks of Vembanad Lake, the Kumarakom Bird Sanctuary 
                  is a haven for ornithologists and nature lovers. The sanctuary is home to numerous 
                  local and migratory birds that flock here during different seasons.
                </p>
                <p className="bird-description">
                  The best time to visit is from June to August when migratory birds like Siberian 
                  storks, egrets, herons, and teals make their way to this paradise. The sanctuary 
                  offers boat cruises that provide excellent opportunities for bird watching and 
                  photography.
                </p>
                <div className="bird-species">
                  <h4>Bird Species You Can Spot</h4>
                  <div className="species-grid">
                    {birdSpecies.map((bird, index) => (
                      <div key={index} className="species-item">
                        <i className="fas fa-dove"></i>
                        <div>
                          <strong>{bird.name}</strong>
                          <span>{bird.season}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Houseboat Experience Section */}
        <div className="houseboat-experience-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="houseboat-experience-content">
                <div className="houseboat-exp-badge">Iconic Experience</div>
                <h2 className="houseboat-exp-title">Luxury Houseboat Cruises</h2>
                <p className="houseboat-exp-description">
                  A houseboat cruise in Kumarakom is an unforgettable experience. These traditional 
                  Kettuvallams have been transformed into luxurious floating accommodations, offering 
                  modern amenities while preserving their rustic charm.
                </p>
                <p className="houseboat-exp-description">
                  As you glide through the serene backwaters, you'll witness the daily life of villagers 
                  along the banks, lush paddy fields, and an incredible variety of birds. The onboard 
                  chef prepares delicious authentic Kerala meals, making your journey a culinary delight.
                </p>
                <div className="houseboat-features">
                  <div className="feature">
                    <i className="fas fa-utensils"></i>
                    <span>Traditional Kerala Cuisine</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-bed"></i>
                    <span>AC Deluxe Bedrooms</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-sun"></i>
                    <span>Open Deck with Sun loungers</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-wifi"></i>
                    <span>Modern Amenities</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Culinary Section */}
        <div className="culinary-section">
          <Grid>
            <div className="section-header">
              <h2 className="section-title-centered">Culinary Delights</h2>
              <p className="section-subtitle">Taste the authentic flavors of backwater cuisine</p>
            </div>
            <Row className="culinary-grid">
              {culinaryDelights.map((item, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="culinary-col">
                  <div className="culinary-card">
                    <div className="culinary-icon">
                      <i className="fas fa-utensil-spoon"></i>
                    </div>
                    <h4 className="culinary-name">{item.name}</h4>
                    <p className="culinary-description">{item.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Kumarakom</h2>
              <p className="dest-section-subtitle">Make the most of your visit to the backwater paradise</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-ship"></i>
                  </div>
                  <h4>Book Houseboat Early</h4>
                  <p>Houseboats get booked quickly during peak season (Oct-Feb). Book at least 2-3 weeks in advance.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-binoculars"></i>
                  </div>
                  <h4>Best Time for Bird Watching</h4>
                  <p>Early morning (6:00 AM - 8:00 AM) is the best time to spot birds at the sanctuary.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-camera"></i>
                  </div>
                  <h4>Capture the Moments</h4>
                  <p>Best photography times are during sunrise and sunset. Don't forget your binoculars for bird watching.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-mosquito"></i>
                  </div>
                  <h4>Mosquito Protection</h4>
                  <p>Carry mosquito repellent, especially if you're staying in a houseboat or near the water.</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Experience the Serenity of Kumarakom</h3>
            <p>Let us help you plan your perfect backwater getaway</p>
            <Link to="/contact" className="dest-cta-button">
              Plan Your Trip
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}